import React from 'react';
import { getExportButtons } from '../utils/exportUtils';

/**
 * Reusable Export Buttons Component
 * 
 * @param {Function} onExport - Function to handle export (receives format: 'csv' | 'xlsx' | 'json')
 * @param {Boolean} isLoading - Loading state to disable buttons
 * @param {String} className - Additional CSS classes for container
 */
const ExportButtons = ({ onExport, isLoading = false, className = '' }) => {
    const buttons = getExportButtons(onExport, isLoading);

    return (
        <div className={`flex gap-2 ${className}`}>
            {buttons.map((button) => (
                <button
                    key={button.format}
                    onClick={button.onClick}
                    className={button.className}
                    disabled={button.disabled}
                >
                    {button.label}
                </button>
            ))}
        </div>
    );
};

export default ExportButtons;
